/**
 * IS THIS STRING SHAPED LIKE A SOLANA ADDRESS?
 *
 * SHAPE ONLY, and deliberately so. The server validates by DECODING — a 32–44 character base58 string can
 * decode to 31 or 33 bytes, and only a decode catches that — and it answers `400 bad_mint` when the decode
 * fails, on `:mint` and on `:owner` alike. A second, stricter validator in the browser would be a second
 * authority on what an address is, and the two would disagree on exactly the inputs that matter.
 *
 * What this IS for is the navigation box: turning "the user pasted something that cannot possibly be an
 * address" into a local refusal, rather than a route change that renders a token page's seed-failure banner —
 * which reads as an outage instead of as a typo.
 *
 * `1`, `I`, `O` and `l` are absent from the base58 alphabet on purpose: they are the characters that are
 * confusable in a monospace font, which is why an address is base58 rather than base64.
 */
const BASE58_ADDRESS = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

export const looksLikeAddress = (v: string): boolean => BASE58_ADDRESS.test(v.trim());
